import * as z from "zod";
import { OC } from "../../utils";
import { AdminClient } from "../client/schema";
import { AdminTrip } from "../trip/schema";
import { AdminReservation } from "./schema";

export const reservationContract = OC.router({
  get: OC.meta({ permissions: ["reservation:get"] })
    .input(AdminReservation.Get)
    .output(
      AdminReservation.Reservation.extend({
        payments: z.array(AdminReservation.Payment),
        trip: AdminTrip.Trip.omit({
          locations: true,
          groupPricing: true,
        }),
        agencyClient: AdminClient.Client.omit({
          totalAmountDue: true,
        }),
        discount: z
          .object({
            id: z.string(),
            code: z.string(),
            value: z.number(),
            type: z.enum(["PERCENTAGE", "FIXED"]),
          })
          .nullable(),
      }),
    ),

  getAll: OC.meta({ permissions: ["reservation:get"] })
    .input(AdminReservation.GetAll)
    .output(
      z.array(
        AdminReservation.Reservation.extend({
          agencyClient: AdminClient.Client.omit({
            totalAmountDue: true,

            nIdFrontIv: true,
            nIdBackIv: true,
            nIdFrontKey: true,
            nIdBackKey: true,
            encryptionKey: true,
          }),
          trip: AdminTrip.Trip.omit({
            locations: true,
            groupPricing: true,
          }),
        }),
      ),
    ),

  create: OC.meta({
    alters: true,
    permissions: ["reservation:create"],
    auditLog: { modelName: "RESERVATION", action: "CREATE" },
    aragon: "reservation_created",
  })
    .input(AdminReservation.Create)
    .output(
      AdminReservation.Reservation.omit({
        totalPaid: true,
        amountDue: true,
        totalRefunded: true,
        refundDue: true,

        status: true,

        totalPrice: true,
        totalReservationFee: true,
        totalCancellationFee: true,
        totalRefundable: true,
      }),
    ),

  update: OC.meta({
    alters: true,
    permissions: ["reservation:update"],
    auditLog: { modelName: "RESERVATION", action: "UPDATE" },
    aragon: "reservation_updated",
  })
    .input(AdminReservation.Update)
    .output(
      AdminReservation.Reservation.omit({
        totalPaid: true,
        amountDue: true,
        totalRefunded: true,
        refundDue: true,

        status: true,

        totalPrice: true,
        totalReservationFee: true,
        totalCancellationFee: true,
        totalRefundable: true,
      }),
    ),

  addPayment: OC.meta({
    alters: true,
    permissions: ["reservation:update"],
    auditLog: { modelName: "PAYMENT", action: "CREATE" },
    aragon: "payment_created",
  })
    .input(AdminReservation.AddPayment)
    .output(AdminReservation.Payment),

  updatePayment: OC.meta({
    alters: true,
    permissions: ["reservation:update"],
    auditLog: { modelName: "PAYMENT", action: "UPDATE" },
    aragon: "payment_updated",
  })
    .input(AdminReservation.UpdatePayment)
    .output(AdminReservation.Payment),

  voidPayment: OC.meta({
    alters: true,
    permissions: ["reservation:update"],
    auditLog: { modelName: "PAYMENT", action: "DELETE" },
    aragon: "payment_voided",
  })
    .input(AdminReservation.VoidPayment)
    .output(AdminReservation.Payment),
});
